$('.js-common-popup[data-name="med-confirmation"]').each(function() {
    let confirmationId = '';
    if(!$(this).data('confirmation')){
        confirmationId = 'confirmation_' + $(this).data('name');
    } else {
        confirmationId = 'confirmation_' + $(this).data('confirmation');
    }
    const $step1 = $('.js-med-confirmation-step1', this);
    const $step2 = $('.js-med-confirmation-step2', this);
    const $forbidden = $('.js-med-confirmation-forbidden', this);
    const $close = $('.js-common-popup-close', this);

    if (window.localStorage.getItem(confirmationId) == 2) {
        return;
    } else if (window.localStorage.getItem(confirmationId) != 1) {
        App.D.trigger('popup:open', {
            name: 'med-confirmation'
        });

        $('.js-med-confirmation-step1-yes').on('click', function() {
            $step1.removeClass('_visible');
            setTimeout(function() {
                $step1.hide();
                $step2.show();
                setTimeout(function() {
                    $step2.addClass('_visible');
                }, 300);
            }, 300);
        });

        $('.js-med-confirmation-step1-no').on('click', function() {
            forbidden();
        });
    } else {
        App.D.trigger('popup:open', {
            name: 'med-confirmation'
        });

        $step1.hide();
        $step2.show();
        $step2.addClass('_visible');
    }

    $('.js-med-confirmation-step2-yes').on('click', function() {
        $(this).trigger('popup:close');
        window.localStorage.setItem(confirmationId, 1);

        if ($(this).is('[data-nosaved]')) {
            window.localStorage.setItem(confirmationId, 2);
        }
    });

    $('.js-med-confirmation-once').on('click', function() {
        e.preventDefault()
        if(window.location.hash && $(`${window.location.hash}`).length > 0){
            const offsetTopBlock = $(`${window.location.hash}`).offset().top - 200;
            $("html, body").animate({scrollTop: offsetTopBlock}, 800);
        }
        window.localStorage.setItem(confirmationId, 2);
    });

    $('.js-med-confirmation-step2-no').on('click', function() {
        forbidden();
    });

    function forbidden() {
        $step1.hide();
        $step2.hide();
        $forbidden.show();
        $close.remove();
    }
});
